import * as React from "react";

import {useResponsiveness} from "../hooks";

import {useProductListPresentationModel, useReactPlpInitialState,} from "../providers";

import {Breadcrumbs} from "../breadcrumbs";

export const Banner: React.FunctionComponent = (props) => {
  const { initialState } = useReactPlpInitialState();
  const { bannerConfiguration } = initialState;
  const { presentationPageSearchTitle } = useProductListPresentationModel();

  const [breakpoint] = useResponsiveness();

  const bannerImageSrc = React.useMemo(() => {
    return bannerConfiguration?.image?.[breakpoint];
  }, [breakpoint]);

  const isCatalogSearchResult = window.location.href.includes('catalogsearch/result');

  if (!isCatalogSearchResult) {
    return (
        <div className="plp-banner">
          <div className="category-cms"/>
          <div className="content-container">
            <div className="content">
              <Breadcrumbs />
              <div className="page-title-wrapper">
            <span className="page-title page-title-h1" aria-labelledby="page-title-heading toolbar-amount">
              <span className="base">{presentationPageSearchTitle}</span>
            </span>
              </div>
            </div>
          </div>
        </div>
    );
  }else{
    return (
        <div className="plp-banner">
          <div className="category-cms">
            <img
                className="hero"
                src={bannerImageSrc}
                width="1920px"
                height="231px"
            />
            <div className="overlay" />
          </div>
          <div className="content-container">
            <div className="content">
              <Breadcrumbs />
              <div className="page-title-wrapper">
            <span className="page-title page-title-h1" aria-labelledby="page-title-heading toolbar-amount">
              <span className="base">{presentationPageSearchTitle}</span>
            </span>
              </div>
            </div>
          </div>
        </div>
    );
  }

};
